<template>
    <el-dialog :visible.sync="openDialog" width="600px" :title="title" :close-on-click-modal="false">
        <el-form label-width="100px" ref="form" :model="form" :rules="rules" size="small">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="分类编码" prop="code">
                        <el-input v-model="form.code" placeholder="请输入分类编码"/>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="分类名" prop="name">
                        <el-input v-model="form.name" placeholder="请输入分类名"/>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="上级分类" prop="parentId">
                        <treeselect
                            v-model="form.parentId"
                            :show-count="true"
                            :options="optionMenus"
                            :normalizer="normalizer"
                            placeholder="选择上级菜单"
                        />
                        <!-- <el-cascader :props="parentClassProps" v-model="form.parentId" style="width:100%"></el-cascader> -->
                    </el-form-item>
                </el-col>
                <!-- <el-col :span="24">
                    <el-form-item label="状态" prop="status">
                        <el-radio-group v-model="form.status">
                            <el-radio :label="0">启用</el-radio>
                            <el-radio :label="1">停用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col> -->
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="openDialog = false" size="small">取 消</el-button>
            <el-button type="primary" @click="submitForm" size="small">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
// import { addBasicClassify, editBasicClassify, queryByParentId } from '@/api/basic/commodityClassification.js'
import { classAdd,classEdit,queryByParentId } from '@/api/gysmng/index.js'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
export default {
    components:{
        Treeselect
    },
    data(){
        return {
            title: "",
            form: {},
            openDialog: false,
            optionMenus: [],
            rules: {
                code: [{ required: true, message: '请输入分类编码', trigger: 'blur' }],
                name: [{ required: true, message: '请输入分类名', trigger: 'blur' }],
                parentId: [{ required: true, message: '请输入上级分类', trigger: 'blur' }],
                status: [{ required: true, message: '请输入状态0为不启用；1为启用', trigger: 'blur' }],
            },
            parentClassProps: {
                lazy: true,
                checkStrictly: true,
                lazyLoad : async (node, resolve)=> {
                    const { level } = node;
                    let pId = 0
                    if(level < 1){
                        pId = 0;
                    }else{
                        pId = node.data.id;
                    }
                    const { data: res } = await queryByParentId({id:pId});
                    if (res.code == 0) {
                        let nodes = res.data || [];
                        nodes.forEach((no)=>{
                            no['value'] = no.id;
                            no['label'] = no.name;
                            if(level<1){
                                 no['label'] = '一级分类';
                            }
                            no['leaf'] = !no.existNextLevel;
                        })
                        resolve(nodes);
                    }
                }
            },
        }
    },
    methods:{
        async getMenuData(callback){
            let _this = this;
            const { data: res } = await queryByParentId({});
            if (res.code == 0) {
                let nodes = res.data || [];
                // nodes.forEach((no)=>{
                //     no['name'] = '一级分类';
                // })
                if(callback){
                    callback(nodes)
                }
            }
        },
        normalizer(node) {
            //删除 数据的子集
            if (node.children && !node.children.length) {
                delete node.children;
            }
            return {
                id: node.id,
                //将name转换成必填的label键
                label: node.name,
                children: node.children
            };
        },
        /** 查询菜单下拉树结构 */
        getTreeselect() {
            let _this = this;
            _this.optionMenus = [];
            this.getMenuData((data)=>{
                _this.optionMenus.push(data[0]);
            })
        },
        // 表单重置
        reset: function () {
            this.form = {
                id: undefined,
                code: undefined,
                name: undefined,
                parentId: undefined,
                // status: 0,
            }
            if (this.$refs["form"] !== undefined) {
                this.$refs["form"].resetFields();
            }
        },
        submitForm() {
            let _this = this;
            _this.$refs['form'].validate((valid) => {
                if (valid) {
                    // return
                    if (_this.form.id != undefined) {
                        classEdit(_this.form).then(response => {
                            if (response.data.code === 0) {
                                _this.$success(response.data.msg);
                                _this.openDialog = false;
                                _this.$emit('callback',{type:'getlist'})
                            } else {
                                _this.$fail(response.data.msg);
                            }
                        });
                    } else {
                        let newForm = {
                            code:_this.form.code,
                            name:_this.form.name,
                            parentId:_this.form.parentId,
                        }
                        classAdd(newForm).then(response => {
                            if (response.data.code === 0) {
                                _this.$success(response.data.msg);
                                _this.openDialog = false;
                                // _this.getList();
                                _this.$emit('callback',{type:'getlist'})
                            } else {
                                _this.$fail(response.data.msg);
                            }
                        });
                    }
                }
            });
        },
    },
}
</script>

<style lang="sass" scoped>

</style>

